import { mergeWith, isNull, merge, keyBy, isUndefined } from 'lodash';
import * as types from '../constants/action-types';

const initialState = {
  spaces: [],
  spaceById: {},
  selectedSpace: '',
  month_events: {},
  day_events: {
    isFetching: false,
    events: []
  },
  selectedDate: new Date(),
  isFetching: false,
  loadCalendar: false,
  loadCalendarAndDayEvents: false,
  operating_hours: [],
  enforce_social_events_op_hours: false,
  isPosting: false,
  lastUpdated: '',
  lastUpdatedDate: '',
  error: ''
};

export default function calendar (state = initialState, action) {
  const {
    spacesArray,
    selectedSpace,
    selectedDate,
    month_events,
    day_events,
    error,
    loadCalendar,
    loadCalendarAndDayEvents,
    operating_hours,
    enforce_social_events_op_hours,
    lastUpdated,
    lastUpdatedDate,
    isPosting
  } = action;
  // customizer resets objects/ array from non-empty to empty
  const mergeCustomizer = (objectValue, sourceValue) => {
    if (!isNull(sourceValue) || !isUndefined(sourceValue)) {
      return sourceValue;
    }
    return objectValue;
  };

  switch (action.type) {
  case types.CALENDAR_SPACES_FETCH_SUCCESS:
    return merge({}, state, {
      spaces: spacesArray,
      spaceById: keyBy(spacesArray, '_id'),
      error
    });

  case types.CALENDAR_SPACES_FETCH_FAILURE:
    return merge({}, state, {
      error
    });

  case types.SPACES_SELECT:
    return merge({}, state, {
      selectedSpace,
      loadCalendarAndDayEvents
    });

  case types.CALENDAR_FETCH_FAILURE:
    return merge({}, state, {
      error,
      loadCalendar,
      loadCalendarAndDayEvents
    });

  case types.CALENDAR_FETCH_SUCCESS:
    return mergeWith({}, state, {
      month_events,
      lastUpdated,
      lastUpdatedDate,
      error,
      loadCalendar,
      loadCalendarAndDayEvents
    }, mergeCustomizer);

  case types.OPHOURS_FETCH_REQUEST:
    return merge({}, state, {
      isFetching: true
    });

  case types.OPHOURS_FETCH_FAILURE:
    return merge({}, state, {
      isFetching: false,
      error,
      operating_hours,
      enforce_social_events_op_hours
    });

  case types.OPHOURS_FETCH_SUCCESS:
    return mergeWith({}, state, {
      isFetching: false,
      error,
      operating_hours,
      enforce_social_events_op_hours
    }, mergeCustomizer);


  case types.OPHOURS_POST_REQUEST:
    return merge({}, state, {
      isPosting
    });

  case types.OPHOURS_POST_FAILURE:
    return merge({}, state, {
      isPosting,
      error,
      operating_hours
    });

  case types.OPHOURS_POST_SUCCESS:
    return mergeWith({}, state, {
      isPosting,
      error,
      operating_hours
    }, mergeCustomizer);

  case types.DATE_SELECT:
    return selectedDate && merge({}, state, {
      selectedDate
    });

  case types.DAY_EVENTS_FETCH_REQUEST:
    return merge({}, state, {
      day_events
    });

  case types.DAY_EVENTS_FETCH_SUCCESS:
    return mergeWith({}, state, {
      day_events,
      error,
      loadCalendarAndDayEvents
    }, mergeCustomizer);

  case types.DAY_EVENTS_FETCH_FAILURE:
    return merge({}, state, {
      error,
      day_events,
      loadCalendarAndDayEvents
    });

  case types.POST_BLOCK_DAY_SUCCESS:
    return mergeWith({}, state, {
      day_events,
      error,
      loadCalendarAndDayEvents
    }, mergeCustomizer);

  case types.POST_BLOCK_DAY_FAILURE:
    return merge({}, state, {
      error,
      loadCalendarAndDayEvents
    });

  case types.DELETE_BLOCK_DAY_SUCCESS:
    return mergeWith({}, state, {
      day_events,
      error,
      loadCalendar
    }, mergeCustomizer);

  case types.DELETE_BLOCK_DAY_FAILURE:
    return merge({}, state, {
      error,
      loadCalendar
    });

  case types.RESET_DAY_EVENTS:
    return mergeWith({}, state, {
      day_events: {
        isFetching: false,
        events: []
      }
    }, mergeCustomizer);

  default:
    return state;
  }
}
